import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const createChatAdmin = createAsyncThunk(
  "chat/createChatAdmin",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post("/api/user/chat/admin/create");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to create chat.");
    }
  }
);

const createChatAdminSlice = createSlice({
  name: "createChatAdmin",
  initialState: {
    chatid: [],
    statusChat: "idle",
    errorChat: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createChatAdmin.pending, (state) => {
        state.statusChat = "loading";
        state.errorChat = null;
        state.chatid = null;
      })
      .addCase(createChatAdmin.fulfilled, (state, action) => {
        state.statusChat = "succeeded";
        state.chatid = action.payload;
      })
      .addCase(createChatAdmin.rejected, (state, action) => {
        state.statusChat = "failed";
        state.errorChat = action.payload;
        state.chatid = null;
      });
  },
});

export default createChatAdminSlice.reducer;
